function checkSpace(str) {
	return str.search(/\s/) !== -1;
}

function isHangul(str) {
	let result = true;

	for (let i = 0; i < str.length; i++) {
		if (
			str.charCodeAt(i) !== 32 &&
			(str.charCodeAt(i) < 44032 || str.charCodeAt(i) > 55203)
		) {
			result = false;
			break;
		}
	}

	return result;
}

export default {
	getValidUserName(str) {
		let message = '';

		if (!str) {
			message = '이름을 입력하세요.';
			return message;
		}

		if (checkSpace(str)) {
			message = '이름은 띄어쓰기 없이 입력하세요.';
			return message;
		}

		if (!isHangul(str)) {
			message = '이름을 한글로 입력하세요.';
			return message;
		}

		if (str.length > 10) {
			message = '이름은 10자까지만 사용할 수 있습니다.';
			return message;
		}

		return message;
	},
	getValidUserHp(str) {
		let message = '';

		if (!str) {
			message = '휴대전화 번호를 입력하세요.';
			return message;
		}

		const regExp = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
		if (!regExp.test(str)) {
			message = '휴대전화 번호를 -없이 숫자만 올바르게 입력하세요.';
			return message;
		}

		return message;
	},
	getValidUserId(str) {
		let message = '';

		if (!str) {
			message = '아이디를 입력하세요.';
			return message;
		}

		// 아이디 가운데 빈 공간이 없도록 체크한다.
		if (checkSpace(str)) {
			message =
				'아이디는 빈 공간 없이 6~12자의 영문 소문자와 숫자, 특수기호(_)만 사용할 수 있습니다.';
			return message;
		}

		// 아이디는 '-' 로 시작할 수 없다.
		if (str.charAt(0) === '_') {
			message = "아이디의 첫 문자는 '_'로 시작할 수 없습니다.";
			return message;
		}

		// 길이와 허용 문자를 체크한다.
		let isID = /^[a-z0-9_]{6,12}$/;
		if (!isID.test(str)) {
			message =
				'아이디는 6~12자의 영문 소문자와 숫자, 특수기호(_)만 사용할 수 있습니다.';
			return message;
		}

		let isNum = /\d/;
		let cnt = 0;
		for (let i = 0; i < str.length; i++) {
			if (isNum.test(str.substring(i, i + 1))) {
				cnt++;
			}
			if (cnt > 7) {
				message = '같은 숫자를 7개 이상 사용할 수 없습니다.';
				break;
			}
		}

		return message;
	},
	getValidUserPw(str, userId) {
		if (!str) {
			return '비밀번호를 입력하세요.';
		}

		if (checkSpace(str)) {
			return '비밀번호에는 공백이 있으면 안됩니다.';
		}

		if (userId === str) {
			return '아이디와 비밀번호가 같습니다.\n보안 상의 이유로 아이디와 같은 비밀번호는 허용하지 않습니다.';
		}

		const invalidPwMsg =
			'비밀번호는 8~16자의 영문 대소문자, 숫자, 특수문자 중 2종류 이상 조합으로 사용할 수 있습니다.';

		/**
		 * 8~16자의 영문대소문자, 숫자, 특수문자 중 2종류 이상의 조합
		 *
		 * e.g.
		 * Password1 // 영문 + 숫자
		 * hello@2024 // 영문 + 특수문자
		 * Secure#99 // 영문 + 특수문자 + 숫자
		 * P@ssword123 // 영문 + 숫자 + 특수문자
		 */
		// eslint-disable-next-line
		const isValidPassword = /^(?=.*[A-Za-z])(?=.*\d|.*[\W_])[A-Za-z\d\W_]{8,16}$/.test(
			str,
		);

		if (!isValidPassword) {
			return invalidPwMsg;
		}

		return '';
	},
	getValidReUserPw(str, userPw) {
		let message = '';

		if (!str) {
			message = '비밀번호 확인을 입력하세요.';
			return message;
		}

		if (userPw !== str) {
			message = '비밀번호가 일치하지 않습니다.';
			return message;
		}

		return message;
	},
	getValidUserEmail(str) {
		let message = '';

		if (!str) {
			message = '이메일 주소를 입력하세요.';
			return message;
		}

		if (checkSpace(str)) {
			message = '이메일 주소를 빈공간 없이 넣으세요.';
			return message;
		}

		// 기존 하이모 회원가입 정규식이 올바르지 않아서 새로 수정함.
		const isEmail =
			/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
		if (!isEmail.test(str)) {
			message = '이메일 형식이 잘못 되었습니다.';
			return message;
		}

		if (str.length > 60) {
			message = '이메일 주소는 60자까지 유효합니다.';
			return message;
		}

		return message;
	},
	getValidUserBirth(str) {
		if (!str) {
			return '생년월일을 입력하세요.';
		}

		const isBirth =
			/^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
		if (!isBirth.test(str)) {
			return '생년월일 형식이 잘못 되었습니다.';
		}

		if (
			parseInt(str.substr(0, 4)) < 1900 ||
			parseInt(str.substr(0, 4)) > new Date().getFullYear()
		) {
			return '유효한 생년월일이 아닙니다.';
		}

		// 만나이 체크
		// 하이모측 요청으로 연도만 입력한 연도로 하고 월일은 12월 31일로 설정하여 계산한다.
		const birthday = new Date(`${str.substr(0, 4)}/12/31`);
		const today = new Date();
		let age = today.getFullYear() - birthday.getFullYear();
		const diffMonth = today.getMonth() - birthday.getMonth();
		if (
			diffMonth < 0 ||
			(diffMonth === 0 && today.getDate() < birthday.getDate())
		) {
			age -= 1;
		}

		if (age < 14) {
			return '만 14세 미만은 가입할 수 없습니다.';
		}

		return '';
	},
};
